import { useTranslation } from "@coworker/locales";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import WarningTrianglePath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/WarningTrianglePath";
import styles from "./task-notification.module.css";

const TaskNotificationSafety = () => {
  const { t } = useTranslation();
  return (
    <div className={styles["task-notification-item-body-priority"] ?? ""}>
      <FixaSSRIcon paths={WarningTrianglePath} />
      {t("safetyAlarmString")}
    </div>
  );
};

export default TaskNotificationSafety;
